import { ActionType, createReducer } from 'typesafe-actions';
import { State } from '../types';
import { INITIAL_STATE } from '../constats';
import * as actions from '../actions';
import * as handlers from './handlers';

type Types = ActionType<typeof actions>;

export const platformUiReducer = createReducer<State, Types>(INITIAL_STATE).handleAction(
  actions.switchMode,
  handlers.switchMode,
);
